import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { mmYYYY } from "@/lib/money";

function LotCard({ lot, locations, onDone }) {
  const [moves, setMoves] = useState([{ location_id: "", qty: String(lot.qty) }]);
  const [error, setError] = useState("");
  const set = (i, k, v) => setMoves(moves.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  const go = async () => {
    setError("");
    try {
      await api.post("/inventory/putaway", { lot_id: lot.id, moves });
      toast.success(`${lot.product_name} put away`);
      onDone();
    } catch (e) {
      setError(errMsg(e));
    }
  };
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`putaway-lot-${lot.id}`}>
      <div className="flex flex-wrap items-baseline gap-2">
        <span className="font-display font-bold text-slate-900">{lot.product_name}</span>
        {lot.batch_no && <span className="font-mono text-xs text-slate-500">Batch {lot.batch_no} · exp {mmYYYY(lot.expiry)}</span>}
        <span className="font-mono text-xs text-slate-400">{lot.grn_number}</span>
        <span className="ml-auto rounded-full bg-amber-100 px-2.5 py-0.5 font-mono text-xs font-bold text-amber-900" data-testid={`putaway-waiting-${lot.id}`}>{lot.qty} waiting</span>
      </div>
      <div className="mt-3 space-y-2">
        {moves.map((m, i) => (
          <div key={i} className="flex gap-2">
            <select value={m.location_id} onChange={(e) => set(i, "location_id", e.target.value)} className="h-11 flex-1 rounded-xl border border-slate-200 bg-white px-2 font-mono text-sm" data-testid={`putaway-location-${lot.id}-${i}`}>
              <option value="">Choose location</option>
              {locations.map((l) => <option key={l.id} value={l.id}>{l.code}</option>)}
            </select>
            <input inputMode="numeric" value={m.qty} onChange={(e) => set(i, "qty", e.target.value)} className="h-11 w-24 rounded-xl border border-slate-200 px-3 text-right font-mono" data-testid={`putaway-qty-${lot.id}-${i}`} />
          </div>
        ))}
      </div>
      {error && <div className="mt-2 rounded-lg bg-rose-50 px-3 py-2 text-sm font-semibold text-rose-700" data-testid={`putaway-error-${lot.id}`}>{error}</div>}
      <div className="mt-3 flex gap-2">
        <button onClick={() => setMoves([...moves, { location_id: "", qty: "" }])} className="h-10 rounded-xl border border-slate-200 px-3 text-sm font-semibold" data-testid={`putaway-split-${lot.id}`}>Split</button>
        <button onClick={go} className="ml-auto h-10 rounded-xl bg-slate-900 px-5 text-sm font-bold text-white" data-testid={`putaway-submit-${lot.id}`}>Put away</button>
      </div>
    </div>
  );
}

export default function PutAway() {
  const [lots, setLots] = useState(null);
  const [locations, setLocations] = useState([]);
  const load = useCallback(() => api.get("/inventory/putaway").then((r) => setLots(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => {
    load();
    api.get("/inventory/locations").then((r) => setLocations(r.data.filter((l) => l.active && l.code !== "RECEIVING")));
  }, [load]);
  if (!lots) return null;
  return (
    <div className="grid gap-3 md:grid-cols-2" data-testid="putaway-queue">
      {lots.map((l) => <LotCard key={l.id} lot={l} locations={locations} onDone={load} />)}
      {!lots.length && <div className="rounded-2xl border border-dashed border-slate-300 p-10 text-center text-sm text-slate-400 md:col-span-2" data-testid="putaway-empty">Nothing waiting in RECEIVING</div>}
    </div>
  );
}
